import { Box, Grid, Popover, PopoverProps, Typography } from "@mui/material";
import { styled } from "@mui/styles";
import React, { PropsWithChildren } from "react";
import { I18nTranslator, translations } from "utils/i18n";

interface ILegendModalProps extends PopoverProps {}

const FlexBox = styled(Box)(() => ({
  display: "flex",
}));

export default function LegendModal(props: ILegendModalProps) {
  return (
    <Popover
      {...props}
      anchorOrigin={{
        vertical: "top",
        horizontal: "left",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "right",
      }}
    >
      <Box
        sx={{
          width: "70vh",
          p: 2,
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography
          variant="h3"
          fontWeight={"bold"}
          sx={{ p: "10px 0 20px 0" }}
        >
          {I18nTranslator(translations.report.note)}
        </Typography>
        <Box sx={{ display: "flex", marginBottom: "20px" }}>
          <FlexBox
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              flex: 1,
            }}
          >
            <LegendItem
              backgroundColor="#dedede"
              title={I18nTranslator(translations.report.emptyLocation)}
            />
            <LegendItem
              backgroundColor="white"
              title={I18nTranslator(translations.report.locationHasProduct)}
            >
              <svg id="pallet" viewBox="0 0 24 24" height={40} width={40}>
                {/* <img src={require("../../assets/images/pallet.svg")} /> */}
                <path
                  fill="#0072CE"
                  d="M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L10.11,5.22L16,8.61L17.96,7.5L12,4.15M6.04,7.5L12,10.85L13.96,9.75L8.08,6.35L6.04,7.5M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z"
                />
              </svg>
            </LegendItem>
            <LegendItem
              backgroundColor="#fa5c5c"
              title={I18nTranslator(translations.report.locationSearchResult)}
            >
              <svg id="pallet" viewBox="0 0 24 24" height={40} width={40}>
                {/* <img src={require("../../assets/images/pallet.svg")} /> */}
                <path
                  fill="white"
                  d="M21,16.5C21,16.88 20.79,17.21 20.47,17.38L12.57,21.82C12.41,21.94 12.21,22 12,22C11.79,22 11.59,21.94 11.43,21.82L3.53,17.38C3.21,17.21 3,16.88 3,16.5V7.5C3,7.12 3.21,6.79 3.53,6.62L11.43,2.18C11.59,2.06 11.79,2 12,2C12.21,2 12.41,2.06 12.57,2.18L20.47,6.62C20.79,6.79 21,7.12 21,7.5V16.5M12,4.15L10.11,5.22L16,8.61L17.96,7.5L12,4.15M6.04,7.5L12,10.85L13.96,9.75L8.08,6.35L6.04,7.5M5,15.91L11,19.29V12.58L5,9.21V15.91M19,15.91V9.21L13,12.58V19.29L19,15.91Z"
                />
              </svg>
            </LegendItem>
          </FlexBox>
        </Box>
      </Box>
    </Popover>
  );
}

const LegendItem = (props: {
  backgroundColor: string;
  title: string;
  children?: JSX.Element;
}) => {
  return (
    <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
      <Box
        sx={{
          padding: "6px",
          border: "1px solid black",
          display: "flex",
          marginRight: "6px",
          height: "40px",
          width: "40px",
          backgroundColor: props.backgroundColor,
        }}
      >
        {props.children}
      </Box>
      <Typography>{props.title}</Typography>
    </Box>
  );
};
